import { NoticeLevel } from "@service/components/toast/type/Enums";
import { Notice } from "@service/components/toast/type/Notice";
import { noticeActions } from "@service/store/notice/actions";
import { Dispatch } from "vuex";
import i18n from "@service/locale/i18";
import { BackendErrorInterface } from "@api/models/interfaces/BackendError";

export const saveHandler = (dispatch: Dispatch, resultId?: string, sessionId?: string, ) => {
    // CREATED:
    if (resultId && !sessionId) {

        const notice: Notice = {
            text: i18n.t("agenda.sessionSuccessfullySaved").toString(),
            level: NoticeLevel.success
        }

        dispatch(noticeActions.submitNotice, notice);
    }
    // UPDATED:
    else if (resultId) {
        const notice: Notice = {
            text: i18n.t("agenda.sessionSuccessfullyUpdated").toString(),
            level: NoticeLevel.success
        }

        dispatch(noticeActions.submitNotice, notice);
        //updated
    }
    else {
        const notice: Notice = {
            text: i18n.t("agenda.sessionSaveFailed").toString(),
            level: NoticeLevel.danger
        }

        dispatch(noticeActions.submitNotice, notice);
    }
}

enum ErrorCode {
    updateConcurrency = "system.updateConcurrency"
}

export const errorHandler = (dispatch: Dispatch, data: BackendErrorInterface) => {
    if (data.code === ErrorCode.updateConcurrency) {

        const notice: Notice = {
            text: i18n.t("agenda.form.errors.updateConcurrency").toString(),
            level: NoticeLevel.danger
        }

        dispatch(noticeActions.submitNotice, notice);
    }
}